export interface SetCustomFilterAllValuesPayload {
  filterGroupId: string;
  filterId: string;
  values: string[];
}

export class SetCustomFilterAllValues {
  constructor(public payload: SetCustomFilterAllValuesPayload) {}
}
